import View from './view.vue'

export default [
  {
    path: '/',
    name: 'Home',
    component: View,
  },
  {
    path: '/food/:foodId',
    name: 'HomeFood',
    component: View,
  },
]
